import { Logo } from './Logo';
import { useTranslation } from 'react-i18next';
import './BrandMark.css';

interface BrandMarkProps {
  animated?: boolean;
  className?: string;
}

export function BrandMark({ animated = false, className }: BrandMarkProps) {
  const { t } = useTranslation();
  const classes = ['brand-mark'];
  if (className) {
    classes.push(className);
  }

  return (
    <span className={classes.join(' ')}>
      <Logo animated={animated} variant="inline" />
      <span className="sr-only">{t('brand.name')}</span>
    </span>
  );
}
